import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const LabelItem = props => {
  const { color, id, name, toggleModal } = props

  return (
    <div className='translations-labels-section-item'>
      <i
        className='fa fa-tag translations-labels-section-item__label'
        aria-hidden='true'
        style={{ color: color || null }}
      />
      <p
        className='translations-labels-section-item__name text-ellipsis'
        title={name}
      >
        {name}
      </p>
      <div className='translations-labels-section-item__actions'>
        <button
          className='translations-labels-section-item__btn'
          title={lang('dashboard_edit')}
          type='button'
          onClick={() => toggleModal(id)}
        >
          <figure className='translations-labels-section-item__icon'>
            <img src={getStaticImage('/icons/orange-brand/icon-edit.svg')} alt='Edit' />
          </figure>
        </button>
      </div>
    </div>
  )
}

export default LabelItem
